<template>
  <div>
    <div class="vs-row">
      <vs-col vs-lg="6" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Default</h6>
            </div>
          </header>
          <div class="vs-card--content examplex">
            <vs-dropdown>
              <a class="a-icon mr-2" href="#">
                Dropdown hover
                <vs-icon class="" icon="expand_more"></vs-icon>
              </a>

              <vs-dropdown-menu>
                <vs-dropdown-item> Option 1 </vs-dropdown-item>
                <vs-dropdown-item> Option 2 </vs-dropdown-item>
                <vs-dropdown-item divider> Option 3 </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>

            <vs-dropdown>
              <a class="a-icon" href.prevent>
                Dropdown Option Disabled
                <vs-icon class="" icon="expand_more"></vs-icon>
              </a>

              <vs-dropdown-menu>
                <vs-dropdown-item> Option 1 </vs-dropdown-item>
                <vs-dropdown-item disabled> Option 2 </vs-dropdown-item>
                <vs-dropdown-item disabled divider> Option 3 </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="6" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Button</h6>
            </div>
          </header>
          <div class="vs-card--content examplex">
            <vs-button class="btnx" type="filled">Dropdown</vs-button>
            <vs-dropdown>
              <vs-button
                class="btn-drop"
                type="filled"
                icon="expand_more"
              ></vs-button>
              <!-- <a href="#">Hola mundo</a> -->

              <vs-dropdown-menu>
                <vs-dropdown-item> option 1 </vs-dropdown-item>
                <vs-dropdown-item> option 2 </vs-dropdown-item>
                <vs-dropdown-group>
                  <vs-dropdown-item> option 1 </vs-dropdown-item>
                  <vs-dropdown-item> option 2 </vs-dropdown-item>
                </vs-dropdown-group>
                <vs-dropdown-item divider> option 3 </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>

            <vs-button class="btnx" color="success" type="gradient">Dropdown</vs-button>
            <vs-dropdown>
              <vs-button
                class="btn-drop"
                type="gradient"
                icon="more_horiz"
                color="success"
              ></vs-button>
              <!-- <a href="#">Hola mundo</a> -->

              <vs-dropdown-menu>
                <vs-dropdown-item> Home </vs-dropdown-item>
                <vs-dropdown-item> Contributors </vs-dropdown-item>
                <vs-dropdown-item divider> Logout </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>

            <vs-button class="btnx" color="danger" type="line">Icons</vs-button>
            <vs-dropdown>
              <vs-button
                class="btn-drop"
                type="line"
                icon="mood"
                color="danger"
              ></vs-button>
              <!-- <a href="#">Hola mundo</a> -->

              <vs-dropdown-menu>
                <vs-dropdown-item>
                  <vs-icon class="" icon="mood"></vs-icon>
                </vs-dropdown-item>
                <vs-dropdown-item>
                  <vs-icon class="" icon="mood_bad"></vs-icon>
                </vs-dropdown-item>
                <vs-dropdown-item>
                  <vs-icon class="" icon="sentiment_dissatisfied"></vs-icon>
                </vs-dropdown-item>
                <vs-dropdown-item>
                  <vs-icon class="" icon="sentiment_satisfied"></vs-icon>
                </vs-dropdown-item>
                <vs-dropdown-item>
                  <vs-icon
                    class=""
                    icon="sentiment_very_dissatisfied"
                  ></vs-icon>
                </vs-dropdown-item>
                <vs-dropdown-item>
                  <vs-icon class="" icon="sentiment_very_satisfied"></vs-icon>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </div>
        </div>
      </vs-col>
    </div>
  </div>
</template>
<script>
import { Carousel, Slide } from "vue-carousel";
export default {
  components: {
    Carousel,
    Slide,
  },
  watch: {
    "$store.state.theme"(val) {
      this.chartTheme(val);
    },
  },
  methods: {
    chartTheme(val) {
      let mode = val == "dark" ? "dark" : "light";
      return mode;
    },
  },
  mounted() {
    this.chartTheme(this.$store.state.theme);
  },
  data: () => ({ colorx: "#c72a75", colorx2: "#5252e8" }),
};
</script>
